import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { WebhookLogTable } from './WebhookLogTable'
import { FieldMappingsTable } from './FieldMappingsTable'
import type { IntegrationSource } from '../types'

const triggerCls =
  'px-3 py-1.5 text-sm rounded-none border-b-2 border-transparent data-[state=active]:border-sky-600 data-[state=active]:text-sky-900 data-[state=active]:bg-transparent data-[state=active]:shadow-none'

/** Prawy panel: nagłówek źródła + taby (historia webhooków / mapowania pól). */
export function SourceDetailPanel({ source }: { source: IntegrationSource }) {
  return (
    <main className="flex-1 overflow-auto p-6">
      <div className="mb-4">
        <h1 className="text-lg font-semibold text-slate-900">{source.name}</h1>
        <p className="text-sm text-slate-500 font-mono">
          {source.code} · {source.authType} · {source.isActive ? 'aktywne' : 'nieaktywne'}
        </p>
        {source.allowedOriginPatterns.length > 0 && (
          <div className="mt-2 flex flex-wrap gap-1">
            {source.allowedOriginPatterns.map(p => (
              <code key={p} className="rounded bg-slate-100 px-2 py-0.5 text-[11px] font-mono">{p}</code>
            ))}
          </div>
        )}
      </div>

      <Tabs defaultValue="webhooks" className="flex flex-col gap-3">
        <TabsList className="rounded-none w-full justify-start gap-1 px-0 border-b border-slate-200 bg-transparent h-auto py-0 shadow-none">
          <TabsTrigger value="webhooks" className={triggerCls}>Historia webhooków</TabsTrigger>
          <TabsTrigger value="mappings" className={triggerCls}>Mapowania pól</TabsTrigger>
        </TabsList>
        <TabsContent value="webhooks">
          <WebhookLogTable sourceCode={source.code} />
        </TabsContent>
        <TabsContent value="mappings">
          <FieldMappingsTable sourceCode={source.code} />
        </TabsContent>
      </Tabs>
    </main>
  )
}
